// extracted by mini-css-extract-plugin
export default {"row":"_29fgS"};